import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { TranslocoPipe } from "@jsverse/transloco";
import { MatButton } from "@angular/material/button";

@Component({
  selector: "loren-loren-asset-details-delete-dialog",
  imports: [TranslocoPipe, MatDialogModule, MatButton],
  templateUrl: "./loren-asset-details-delete-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./loren-asset-details-delete-dialog.component.scss",
})
export class LorenAssetDetailsDeleteDialogComponent {
  dialogRef = inject<MatDialogRef<LorenAssetDetailsDeleteDialogComponent>>(MatDialogRef);
  data = inject<{
    assetName: string;
}>(MAT_DIALOG_DATA);


  onCancel(): void {
    this.dialogRef.close();
  }
}
